import { Decimal } from 'decimal.js';
import { NumberInput, NumberInputProps } from 'react-admin';

// Empty value is represented by ''
export const formatValue = (value: number | ''): number | '' =>
  value === '' ? '' : new Decimal(value).div(100).toNumber();
export const parseValue = (value: number | ''): number | '' =>
  value === '' ? '' : Math.round(value * 100);

type AmountInputProps = NumberInputProps & { testId?: string };

export const AmountInput = (props: AmountInputProps) => {
  const { source, testId, ...additionalProps } = props;

  return (
    <NumberInput
      data-testid={testId}
      {...additionalProps}
      source={source}
      parse={(value: number) => parseValue(value)}
      format={(value: number) => formatValue(value)}
    />
  );
};
